// Roland Garros 2026 - Programme complet + Normalisation intelligente
// Détecte: R1, DEMI1, Final men, 24 May, Chatrier, Lenglen, etc.

export const RG_SCHEDULE = [
  // Day 1 - Sunday 24 May 2026
  { day: 1, date: "24/05/2026", phase: "1st Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 1, date: "24/05/2026", phase: "1st Round", session: null, court: "Outside Courts" },
  { day: 1, date: "24/05/2026", phase: "1st Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 1, date: "24/05/2026", phase: "1st Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 2 - Monday 25 May 2026
  { day: 2, date: "25/05/2026", phase: "1st Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 2, date: "25/05/2026", phase: "1st Round", session: null, court: "Outside Courts" },
  { day: 2, date: "25/05/2026", phase: "1st Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 2, date: "25/05/2026", phase: "1st Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 3 - Tuesday 26 May 2026
  { day: 3, date: "26/05/2026", phase: "1st Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 3, date: "26/05/2026", phase: "1st Round", session: null, court: "Outside Courts" },
  { day: 3, date: "26/05/2026", phase: "1st Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 3, date: "26/05/2026", phase: "1st Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 4 - Wednesday 27 May 2026
  { day: 4, date: "27/05/2026", phase: "2nd Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 4, date: "27/05/2026", phase: "2nd Round", session: null, court: "Outside Courts" },
  { day: 4, date: "27/05/2026", phase: "2nd Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 4, date: "27/05/2026", phase: "2nd Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 5 - Thursday 28 May 2026
  { day: 5, date: "28/05/2026", phase: "2nd Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 5, date: "28/05/2026", phase: "2nd Round", session: null, court: "Outside Courts" },
  { day: 5, date: "28/05/2026", phase: "2nd Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 5, date: "28/05/2026", phase: "2nd Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 6 - Friday 29 May 2026
  { day: 6, date: "29/05/2026", phase: "3rd Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 6, date: "29/05/2026", phase: "3rd Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 6, date: "29/05/2026", phase: "3rd Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  { day: 6, date: "29/05/2026", phase: "3rd Round", session: null, court: "Outside Courts" },
  // Day 7 - Saturday 30 May 2026
  { day: 7, date: "30/05/2026", phase: "3rd Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 7, date: "30/05/2026", phase: "3rd Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 7, date: "30/05/2026", phase: "3rd Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  { day: 7, date: "30/05/2026", phase: "3rd Round", session: null, court: "Outside Courts" },
  // Day 8 - Sunday 31 May 2026
  { day: 8, date: "31/05/2026", phase: "4th Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 8, date: "31/05/2026", phase: "4th Round", session: null, court: "Outside Courts" },
  { day: 8, date: "31/05/2026", phase: "4th Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 8, date: "31/05/2026", phase: "4th Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 9 - Monday 1 June 2026
  { day: 9, date: "01/06/2026", phase: "4th Round", session: null, court: "Court Suzanne Lenglen" },
  { day: 9, date: "01/06/2026", phase: "4th Round", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 9, date: "01/06/2026", phase: "4th Round", session: "Evening Session", court: "Court Philippe Chatrier" },
  { day: 9, date: "01/06/2026", phase: "4th Round", session: null, court: "Outside Courts" },
  // Day 10 - Tuesday 2 June 2026
  { day: 10, date: "02/06/2026", phase: "Quarterfinals", session: null, court: "Outside Courts" },
  { day: 10, date: "02/06/2026", phase: "Quarterfinal #1", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 10, date: "02/06/2026", phase: "Quarterfinal #2", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 11 - Wednesday 3 June 2026
  { day: 11, date: "03/06/2026", phase: "Quarterfinal #3", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 11, date: "03/06/2026", phase: "Quarterfinal #4", session: "Evening Session", court: "Court Philippe Chatrier" },
  { day: 11, date: "03/06/2026", phase: "Quarterfinals", session: null, court: "Outside Courts" },
  // Day 12 - Thursday 4 June 2026
  { day: 12, date: "04/06/2026", phase: "Women's Semifinals", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 12, date: "04/06/2026", phase: "Women's Semifinals", session: null, court: "Outside Courts" },
  // Day 13 - Friday 5 June 2026
  { day: 13, date: "05/06/2026", phase: "Men's Semifinals", session: null, court: "Outside Courts" },
  { day: 13, date: "05/06/2026", phase: "Men's Semifinal #1", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 13, date: "05/06/2026", phase: "Men's Semifinal #2", session: "Evening Session", court: "Court Philippe Chatrier" },
  // Day 14 - Saturday 6 June 2026
  { day: 14, date: "06/06/2026", phase: "Women's Final", session: "Day Session", court: "Court Philippe Chatrier" },
  { day: 14, date: "06/06/2026", phase: "Women's Final", session: null, court: "Outside Courts" },
  // Day 15 - Sunday 7 June 2026
  { day: 15, date: "07/06/2026", phase: "Men's Final", session: null, court: "Outside Courts" },
  { day: 15, date: "07/06/2026", phase: "Men's Final", session: "Day Session", court: "Court Philippe Chatrier" },
];

// Day labels
const DAY_LABELS = {
  1: "Dimanche 24 Mai", 2: "Lundi 25 Mai", 3: "Mardi 26 Mai",
  4: "Mercredi 27 Mai", 5: "Jeudi 28 Mai", 6: "Vendredi 29 Mai",
  7: "Samedi 30 Mai", 8: "Dimanche 31 Mai", 9: "Lundi 1 Juin",
  10: "Mardi 2 Juin", 11: "Mercredi 3 Juin", 12: "Jeudi 4 Juin",
  13: "Vendredi 5 Juin", 14: "Samedi 6 Juin", 15: "Dimanche 7 Juin",
};
export const getDayLabel = (dayNum) => DAY_LABELS[dayNum] || `Day ${dayNum}`;

// ========== NORMALISATION DES DATES ==========
// Supporte: "24 May", "7 June", "24/05", "05/06/2026", "2026-05-24"
const MONTH_NAMES = {
  'january': '01', 'february': '02', 'march': '03', 'april': '04',
  'may': '05', 'june': '06', 'july': '07', 'august': '08',
  'september': '09', 'october': '10', 'november': '11', 'december': '12',
  'jan': '01', 'feb': '02', 'mar': '03', 'apr': '04',
  'jun': '06', 'jul': '07', 'aug': '08', 'sep': '09', 'oct': '10', 'nov': '11', 'dec': '12',
  'janvier': '01', 'fevrier': '02', 'mars': '03', 'avril': '04',
  'mai': '05', 'juin': '06', 'juillet': '07', 'aout': '08',
  'septembre': '09', 'octobre': '10', 'novembre': '11', 'decembre': '12',
};

export const normalizeDate = (raw) => {
  if (!raw) return null;
  const s = raw.toString().trim();

  // "24 May", "7 June", "24 May 2026"
  const engMatch = s.match(/^(\d{1,2})\s+(\w+)(?:\s+\d{4})?$/i);
  if (engMatch) {
    const dd = engMatch[1].padStart(2, '0');
    const monthKey = engMatch[2].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const mm = MONTH_NAMES[monthKey];
    if (mm) return `${dd}/${mm}/2026`;
  }

  // "May 24", "June 7"
  const engMatch2 = s.match(/^(\w+)\s+(\d{1,2})(?:,?\s+\d{4})?$/i);
  if (engMatch2) {
    const dd = engMatch2[2].padStart(2, '0');
    const monthKey = engMatch2[1].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const mm = MONTH_NAMES[monthKey];
    if (mm) return `${dd}/${mm}/2026`;
  }

  // JJ/MM or JJ/MM/AA or JJ/MM/AAAA
  const frMatch = s.match(/^(\d{1,2})[/\-.](\d{1,2})(?:[/\-.](\d{2,4}))?/);
  if (frMatch) {
    const dd = frMatch[1].padStart(2, '0');
    const mm = frMatch[2].padStart(2, '0');
    return `${dd}/${mm}/2026`;
  }

  // ISO: 2026-05-24
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) return `${isoMatch[3]}/${isoMatch[2]}/2026`;

  return null;
};

// ========== NORMALISATION DES COURTS ==========
export const normalizeCourt = (raw) => {
  if (!raw) return null;
  const lower = raw.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if (lower.includes('chatrier') || lower === 'pc' || lower === 'ppc') return 'Court Philippe Chatrier';
  if (lower.includes('lenglen') || lower === 'sl' || lower === 'csl') return 'Court Suzanne Lenglen';
  if (lower.includes('mathieu') || lower.includes('outside') || lower.includes('ext') || lower.includes('annexe')) return 'Outside Courts';
  return null;
};

// Tribune → Court
const TRIBUNE_TO_COURT = {
  'Court Philippe Chatrier': ['borotra', 'brugnon', 'cochet', 'lacoste', 'mousquetaires', 'presidentielle'],
  'Court Suzanne Lenglen': ['lenglen a', 'lenglen b', 'lenglen c', 'lenglen d'],
};

export const courtFromTribune = (tribuneName) => {
  if (!tribuneName) return null;
  const lower = tribuneName.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  for (const [court, tribunes] of Object.entries(TRIBUNE_TO_COURT)) {
    for (const t of tribunes) {
      if (lower === t || lower.includes(t)) return court;
    }
  }
  return null;
};

// ========== NORMALISATION DES PHASES / ROUNDS ==========
// R1 → 1st Round, DEMI1 → Men's Semifinal #1, Final men → Men's Final
// FINALE + date context: 07/06 → Men's Final, 06/06 → Women's Final
// ANN = ANNEXE = Outside Courts (pas un vrai "phase", traité spécialement)
export const normalizePhase = (raw, dateRaw = null) => {
  if (!raw) return null;
  const s = raw.toString().trim();
  const lower = s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // ANN = ANNEXE = Outside Courts → pas une phase, retourne spécial
  if (/^ann\b/i.test(s) || lower === 'annexe' || lower === 'annexes') return '__OUTSIDE__';

  // R1, R2, R3, R4
  if (/^r1$/i.test(s) || lower === '1st round' || lower === '1er tour' || lower === 'premier tour' || lower === 'round 1') return '1st Round';
  if (/^r2$/i.test(s) || lower === '2nd round' || lower === '2eme tour' || lower === '2e tour' || lower === 'round 2') return '2nd Round';
  if (/^r3$/i.test(s) || lower === '3rd round' || lower === '3eme tour' || lower === '3e tour' || lower === 'round 3') return '3rd Round';
  if (/^r4$/i.test(s) || lower === '4th round' || lower === '4eme tour' || lower === '4e tour' || lower === 'round 4' || lower === 'huitieme' || lower === '8eme') return '4th Round';

  // Quarterfinals
  if (/^qf\s?1$/i.test(s) || lower === 'quarterfinal #1' || lower === 'quart 1') return 'Quarterfinal #1';
  if (/^qf\s?2$/i.test(s) || lower === 'quarterfinal #2' || lower === 'quart 2') return 'Quarterfinal #2';
  if (/^qf\s?3$/i.test(s) || lower === 'quarterfinal #3' || lower === 'quart 3') return 'Quarterfinal #3';
  if (/^qf\s?4$/i.test(s) || lower === 'quarterfinal #4' || lower === 'quart 4') return 'Quarterfinal #4';
  if (/^qf$/i.test(s) || lower.includes('quarter') || lower.includes('quart')) return 'Quarterfinals';

  // Semifinals - IMPROVED: Detect DAY/NIGHT patterns for Semi 1 vs Semi 2
  // SEMI FINAL DAY MAN → Men's Semifinal #1 (Day Session)
  // SEMI FINAL NIGHT MAN → Men's Semifinal #2 (Evening Session)
  // EXPLICIT: SEMI FINAL 1 or SEMI FINAL 2 in name
  if (/semi\s*final\s*1/i.test(s) || /demi\s*1/i.test(s)) return "Men's Semifinal #1";
  if (/semi\s*final\s*2/i.test(s) || /demi\s*2/i.test(s)) return "Men's Semifinal #2";
  if (lower.includes('semi') && lower.includes('day') && (lower.includes('man') || lower.includes('men') || lower.includes('homme'))) return "Men's Semifinal #1";
  if (lower.includes('semi') && (lower.includes('night') || lower.includes('evening') || lower.includes('nuit') || lower.includes('soir')) && (lower.includes('man') || lower.includes('men') || lower.includes('homme'))) return "Men's Semifinal #2";
  
  // Women's semifinals
  if (lower.includes('semi') && (lower.includes('women') || lower.includes('woman') || lower.includes('femme') || lower.includes('dame'))) return "Women's Semifinals";
  
  // Standard semifinal patterns
  if (/^(sf\s?1|demi\s?1|semi\s?1)$/i.test(s) || lower.includes('semifinal #1') || lower === 'demi1') return "Men's Semifinal #1";
  if (/^(sf\s?2|demi\s?2|semi\s?2)$/i.test(s) || lower.includes('semifinal #2') || lower === 'demi2') return "Men's Semifinal #2";
  if (lower.includes('semi') && (lower.includes('men') || lower.includes('homme') || lower.includes('messieurs'))) return "Men's Semifinals";
  if (/^(sf|demi|semi)$/i.test(s)) return "Men's Semifinals";

  // Finals with gender - CHECK WOMEN FIRST to avoid "MAN" matching in "WOMAN"
  if (/final.*women/i.test(s) || /women.*final/i.test(s) || lower.includes('final women') || lower.includes('finale femme') || lower.includes('finale dame')) return "Women's Final";
  if (/final.*woman/i.test(s) || /woman.*final/i.test(s)) return "Women's Final";
  // Now check for MEN (after WOMEN to avoid false match)
  if (/final.*\bman\b/i.test(s) || /\bman\b.*final/i.test(s) || lower.includes('final man') || lower === 'finale hommes' || lower === 'finale messieurs') return "Men's Final";
  if (/final.*\bmen\b/i.test(s) || /\bmen\b.*final/i.test(s)) return "Men's Final";
  if (/finale?\s*h$/i.test(s)) return "Men's Final";
  if (/finale?\s*f$/i.test(s)) return "Women's Final";

  // "FINALE" seul → utiliser la date pour déterminer Men's ou Women's
  if (/^finale?$/i.test(s)) {
    const normDate = normalizeDate(dateRaw);
    if (normDate === '06/06/2026') return "Women's Final";
    return "Men's Final"; // Default: 07/06 = Men's Final
  }

  return null;
};

// ========== NORMALISATION DES SESSIONS ==========
export const normalizeSession = (raw) => {
  if (!raw) return null;
  const lower = raw.toString().toLowerCase().trim();
  if (lower === 'day' || lower === 'jour' || lower === 'day session' || lower === 'session jour' || lower === 'd' || lower === '1') return 'Day Session';
  if (lower === 'evening' || lower === 'night' || lower === 'nuit' || lower === 'soir' || lower === 'evening session' || lower === 'session soir' || lower === 'n' || lower === 'e' || lower === '2') return 'Evening Session';
  return null;
};

// ========== LOOKUP INTELLIGENT ==========
export const findMatch = (dateRaw, courtRaw = null, sessionRaw = null, tribuneRaw = null, phaseRaw = null) => {
  const normDate = normalizeDate(dateRaw);
  let court = normalizeCourt(courtRaw);
  if (!court && tribuneRaw) court = courtFromTribune(tribuneRaw);
  const normSession = normalizeSession(sessionRaw);
  const normPhase = normalizePhase(phaseRaw, dateRaw);

  // ANN / ANNEXE → force Outside Courts
  if (normPhase === '__OUTSIDE__') {
    court = 'Outside Courts';
  }
  const actualPhase = normPhase === '__OUTSIDE__' ? null : normPhase;

  if (!normDate) return null;

  // 1. Filter by date
  let candidates = RG_SCHEDULE.filter(m => m.date === normDate);
  if (candidates.length === 0) return null;

  // 2. Filter by court
  if (court) {
    const courtFiltered = candidates.filter(m => m.court === court);
    if (courtFiltered.length > 0) candidates = courtFiltered;
  }

  // 3. Filter by session
  if (normSession) {
    const sessionFiltered = candidates.filter(m => m.session === normSession);
    if (sessionFiltered.length > 0) candidates = sessionFiltered;
  }

  // 4. Filter by phase (from ROUND/GAME column)
  if (actualPhase) {
    const phaseFiltered = candidates.filter(m => m.phase === actualPhase);
    if (phaseFiltered.length > 0) candidates = phaseFiltered;
    else {
      // Partial match
      const partial = candidates.filter(m => m.phase.includes(actualPhase) || actualPhase.includes(m.phase));
      if (partial.length > 0) candidates = partial;
    }
  }

  // 5. If still multiple, use phase to infer session
  if (candidates.length > 1 && actualPhase && !normSession) {
    // DEMI1 / Semifinal #1 / QF1/QF3 → Day Session
    if (actualPhase.includes('#1') || actualPhase.includes('#3')) {
      const day = candidates.find(m => m.session === 'Day Session');
      if (day) return day;
    }
    // DEMI2 / Semifinal #2 / QF2/QF4 → Evening Session
    if (actualPhase.includes('#2') || actualPhase.includes('#4')) {
      const eve = candidates.find(m => m.session === 'Evening Session');
      if (eve) return eve;
    }
  }

  return candidates[0];
};

// ========== BUILD MATCH NAME ==========
export const buildMatchName = (entry) => {
  if (!entry) return null;
  const { day, phase, session, court } = entry;
  let name = `M${day} - Day ${day} - ${phase}`;
  if (session) name += ` - ${session}`;
  if (court === 'Court Philippe Chatrier') name += ' - Chatrier';
  else if (court === 'Court Suzanne Lenglen') name += ' - Lenglen';
  else if (court === 'Outside Courts') name += ' - Outside Courts';
  return name;
};

// ========== PARSE COMBINED PLACEMENT ==========
// "C9 S51 R11 S122" → { acces: "C9", escalier: "51", rang: "11", seat: "122" }
// "C8 S49 R7 S23" → { acces: "C8", escalier: "49", rang: "7", seat: "23" }
export const parsePlacement = (raw) => {
  if (!raw) return null;
  const s = raw.toString().trim();
  // Pattern: C{acces} S{escalier} R{rang} S{seat}
  const m = s.match(/^([A-Z]?\d+)\s+S?(\d+)\s+R(\d+)\s+S?(\d+)$/i);
  if (m) {
    return {
      acces: m[1].toUpperCase().startsWith('C') ? m[1] : `C${m[1]}`,
      escalier: m[2],
      rang: m[3],
      seat: m[4],
    };
  }
  // Fallback pattern with explicit labels
  const m2 = s.match(/C(\d+)\s*S(\d+)\s*R(\d+)\s*S(\d+)/i);
  if (m2) {
    return { acces: `C${m2[1]}`, escalier: m2[2], rang: m2[3], seat: m2[4] };
  }
  return null;
};

// ========== AUTO-FILL MATCH NAME ==========
export const autoFillMatchName = (dateRaw, courtRaw = null, sessionRaw = null, tribuneRaw = null, phaseRaw = null) => {
  const entry = findMatch(dateRaw, courtRaw, sessionRaw, tribuneRaw, phaseRaw);
  if (entry) return buildMatchName(entry);

  // Fallback: at least return day info from date
  const normDate = normalizeDate(dateRaw);
  if (normDate) {
    const matches = RG_SCHEDULE.filter(m => m.date === normDate);
    if (matches.length > 0) {
      const { day, phase } = matches[0];
      return `M${day} - Day ${day} - ${phase}`;
    }
  }
  return null;
};
